import { MusicEntity } from '~/features/dashboard/store/models';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectDetectSongChange } from '~/features/dashboard/store/selectors';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { DealSummaryListDto } from '~/models/deals/DealsListItem.dto';
import { MusicApi } from '~/api/music.api';
import { getDealSummaryThunk } from '~/features/dashboard/store/actions.thunks';
import { detectSongChange, isSongFormEditing } from '~/features/dashboard/store/actions';
import { axiosInstance } from '~/api/config/axios.config';
import css from '~/features/dashboard/components/song-details/styles.module.scss';
import { PageTitle } from '~/features/dashboard/components/page-title';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';
import { DownloadButton } from '~/common/download-button';
import { Box, Button, Chip, Collapse, Divider, Drawer, List, ListItem, ListItemText, Tooltip, Typography, Zoom } from '@material-ui/core';
import { DealsTab } from '~/features/dashboard/components/song-details/coponents/DealsTab';
import MetaCardInfoRow from '~/features/dashboard/components/song-details/coponents/MetaCardInfoRow';
import { CancelOutlined as CancelIcon, CheckCircleOutlineOutlined as CheckCircleIcon } from '@material-ui/icons';
import classNames from 'classnames';
import { Pagination } from '@material-ui/lab';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { TODODRAWER } from '~/features/dashboard/components/todo-drawer';
import * as uuid from 'uuid';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Avatar from '@material-ui/core/Avatar';
import { SongAssets } from '~/features/dashboard/components/song-details/coponents/SongAssets';
import { KeyDateTypes } from '~/models/music/new-song/helpers';
import * as CreatorsListFeature from '~/features/creators-list';
import AppleIcon from '@material-ui/icons/Apple';
import YouTubeIcon from '@material-ui/icons/YouTube';
import axios from 'axios';
import { DSPTab } from '~/features/dashboard/components/song-details/coponents/DSPTab';
import { SpotifyIcon } from '~/features/dashboard/components/song-details/coponents/SpotifyIcon';
import { useDateFormat } from '~/common/date-format';

interface SongDetailsProps {
    song: MusicEntity;
    tagDetails: any;
    onLinkingDeal: (data: any, type: any) => void;
    deleteAssetsBtn: (data: any) => void;
    downloadImage: (img: string, type: any) => void;
}

interface noteData_props {
    id: number;
    gSongRef: string;
    notes: string;
    completed: number;
    isDelete: number;
}

interface dspData_props {
    DSP: string;
    ISRC: string;
    artistid: string;
    creativeName: string;
    meta: string;
    projectName: string;
    songRef: string;
    songURL: string;
    sourceId: string;
    trackId: string;
    trackname: string;
}

const TwoColumnTable: React.FC<{
    className?: string;
    title: string;
    stepNo: any;
    isDate?: boolean;
    data: { key: string; value: string; type: number }[];
    gotoStepSong: () => void;
}> = ({ className, title, data, stepNo, gotoStepSong, isDate }) => {
    const keyReasons = [
        {
            label: 'Master',
            keyType: KeyDateTypes.MASTER,
        },
        {
            label: 'Retention',
            keyType: KeyDateTypes.RETENTION,
        },
        {
            label: 'Audit',
            keyType: KeyDateTypes.AUDIT,
        },
        {
            label: 'Option',
            keyType: KeyDateTypes.OPTION,
        },
        {
            label: 'General',
            keyType: KeyDateTypes.GENERAL,
        },
    ];
    return (
        <div className={classNames(css.twoColumnTable, className)}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }} className={css.songTitle}>
                <Typography align={'left'} className={'typography gray bold h4Head'} variant={'h4'}>
                    {title.toUpperCase()}
                </Typography>
                {stepNo !== 7 && (
                    <VerticalPopver
                        childClassName={css.editIcon}
                        styleObj={{ alignSelf: 'center', marginRight: '1.5rem' }}
                        actionsList={`edit`}
                        onClickEdit={() => gotoStepSong()}
                    />
                )}
            </div>
            {keyReasons.map(({ keyType, label }) => (
                <div>
                    {data.filter(({ type }) => type === keyType).length > 0 && (
                        <div className={css.keyDatesItem}>
                            <span className={'bold'}>{label.toUpperCase()}</span>
                        </div>
                    )}
                    {data
                        .filter(({ type }) => type === keyType)
                        .map(({ key, value }) => (
                            <div key={key} className={'row'}>
                                <span>{key}</span>
                                <span className={'gray'}>{value}</span>
                            </div>
                        ))}
                </div>
            ))}
        </div>
    );
};

export const SongDetailsComponent: React.FC<SongDetailsProps> = ({ song, onLinkingDeal, tagDetails, deleteAssetsBtn, downloadImage }) => {
    const songChange = useSelector(selectDetectSongChange);
    const match = useRouteMatch<{ creatorId: string }>();
    const route = useAppRoute();
    const dispatch = useThunkDispatch();
    const [dealSummary, setDealSummary] = React.useState<DealSummaryListDto[]>([]);
    const { formatDate } = useDateFormat();

    const [showDealOnBtn, setShowDealOnBtn] = useState('');
    const {
        meta,
        dealDeliveredTo,
        connectedDeals,
        keyDates,
        id,
        neighbouringRights,
        otherEligible,
        publishing,
        masters,
        writerShareEligible,
        songProjectTrack,
        gPublisherName,
        publishingShare,
        gMyWriterName,
        writingShare,
        releaseDate,
    } = song;
    const { title, artist, featArtists } = meta;
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerDSPOpen, setDrawerDSPOpen] = useState(false);
    const [noteDrawer, setNoteDrawer] = useState(false);
    const [drawerTitle, setDrawerTitle] = useState('ADD DEALS');
    const history = useHistory();
    const [notesData, setNotesData] = useState<noteData_props[]>([]);
    const [toDosData, setToDosData] = useState<noteData_props[]>([]);
    const [youTubeData, setYouTubeData] = useState<dspData_props[]>([]);
    const [spotifyData, setSpotifyData] = useState<dspData_props[]>([]);
    const [appleData, setAppleData] = useState<dspData_props[]>([]);
    const [DSPType, setDSPType] = useState<number>(1);
    const keyDatesTableData = useMemo(() => {
        return keyDates.map(({ gSongNotes, gSongNoteEntryDate, gSongNoteType }) => ({
            key: gSongNotes || '',
            value: gSongNoteEntryDate ? formatDate(gSongNoteEntryDate) : '',
            type: gSongNoteType,
        }));
    }, [keyDates, formatDate]);

    const handleDownloadClick = useCallback(() => {
        MusicApi.exportMusicDetails(id).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'].split('; ')[0] }));
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = 'download.zip';
            link.click();
            window.URL.revokeObjectURL(url);
            link.remove();
        });
    }, [id]);
    useEffect(() => {
        if (match.params.creatorId) {
            dispatch(getDealSummaryThunk({ creatorId: Number(match.params.creatorId), songRef: id })).then(data => {
                setDealSummary(data);
            });
            // .finally(() => setIsLoading(false));
        } else {
            route(CreatorsListFeature.FEATURE_ROUTER_PATH);
        }
    }, [dispatch, route, match.params.creatorId, id]);

    useEffect(() => {
        dispatch(detectSongChange({ value: false }));
    }, [dispatch, songChange]);

    const toggleDrawer = (open: any) => {
        setDrawerOpen(open);
    };
    const onLinkDeal = (data: any, type: any) => {
        setDealSummary(deals => deals.map(t => (t.assetCode === data.assetCode ? { ...t, dealSongLinkFlag: type === 'link' ? 1 : 0 } : t)));
        onLinkingDeal(data, type);
    };
    const onlinkDealBtn = (type: any, showDeal: any, title: any) => {
        toggleDrawer(type);
        setShowDealOnBtn(showDeal);
        setDrawerTitle(title);
    };
    const gotoStepSong = async (step: any) => {
        history.push({
            pathname: `/creators-list/${match.params.creatorId}/dashboard/songs/add-song/${id}`,
            state: {
                gotoStep: step,
            },
        });
    };

    React.useEffect(() => {
        axiosInstance.get(`/Catalogue/projectcreator/songtodolist?gSongRef=${song.id}`).then(res => {
            setToDosData(res.data);
        });

        axiosInstance.get(`/Catalogue/projectcreator/songnoteslist?gsongRef=${song.id}`).then(res => {
            setNotesData(res.data);
        });

        axios.get(`http://musicapp-backend.softobiz.net/v1/api/artist/${meta.artist}/linking/1/${song.id}`).then(resp => {
            setSpotifyData(resp.data.data);
        });

        axios.get(`http://musicapp-backend.softobiz.net/v1/api/artist/${meta.artist}/linking/2/${song.id}`).then(resp => {
            setAppleData(resp.data.data);
        });

        axios.get(`http://musicapp-backend.softobiz.net/v1/api/artist/${meta.artist}/linking/3/${song.id}`).then(resp => {
            setYouTubeData(resp.data.data);
        });
    }, [meta.artist, song]);

    React.useEffect(() => {
        dispatch(isSongFormEditing(true));
    }, [dispatch]);
    const [open, setOpen] = React.useState(false);

    // pagination Deals
    const [currentPage, setCurrentPage] = useState(1);
    const [PerPageDeals] = useState(4);

    // Get current Deals
    const indexOfLastDeals = currentPage * PerPageDeals;
    const indexOfFirstDeals = indexOfLastDeals - PerPageDeals;
    const currentDeals = connectedDeals.slice(indexOfFirstDeals, indexOfLastDeals);
    const pageDeals = Math.ceil(connectedDeals.length / 4);

    // pagination songProjectTrack
    const [currentPageTrack, setCurrentPageTrack] = useState(1);
    const [PerPageTrack] = useState(1);

    // Get current songProjectTrack
    const indexOfLastTrack = currentPageTrack * PerPageTrack;
    const indexOfFirstTrack = indexOfLastTrack - PerPageTrack;
    const currentTrack = songProjectTrack.slice(indexOfFirstTrack, indexOfLastTrack);
    const pageTrack = Math.ceil(songProjectTrack.length);

    const handleClick = () => {
        setOpen(!open);
    };
    return (
        <>
            <div className={css.module}>
                <div className={css.header2}>
                    <div className={css.dealSectionTitleeditouter}>
                        {title && (
                            <PageTitle noBorder className={css.songtitle}>
                                {title.toUpperCase()}
                            </PageTitle>
                        )}
                        <VerticalPopver childClassName={css.editIconTitle} actionsList={`edit`} onClickEdit={() => gotoStepSong(0)} />
                    </div>
                    <div className={css.dealSectionTitleeditouterright}>
                        <DownloadButton onClick={handleDownloadClick} className={css.downloadButton} />
                        <DownloadButton buttonFor="save" onClick={() => setNoteDrawer(true)} className={css.downloadButton1} />
                    </div>
                </div>
                <Drawer variant="persistent" anchor={'right'} open={drawerOpen} onClose={() => onlinkDealBtn(false, '', '')} className={css.drawerStyle}>
                    <DealsTab
                        deals={dealSummary}
                        projectId={match.params.creatorId}
                        showDeal={showDealOnBtn}
                        changeToggleDrawer={toggleDrawer}
                        id={id}
                        onLinkDeal={onLinkDeal}
                        onLinkingDeal={onLinkingDeal}
                        drawerTitle={drawerTitle}
                    />
                </Drawer>
                <Drawer variant="persistent" anchor={'right'} open={drawerDSPOpen} onClose={() => setDrawerDSPOpen(false)} className={css.drawerStyle}>
                    <DSPTab
                        dsp={DSPType === 1 ? spotifyData : DSPType === 2 ? appleData : youTubeData}
                        projectId={match.params.creatorId}
                        changeToggleDrawer={value => setDrawerDSPOpen(value)}
                        drawerTitle={drawerTitle}
                    />
                </Drawer>
                <div className={css.content}>
                    <div>
                        <div className={css.songspan}>
                            {<MetaCardInfoRow title={'What rights do you have for this Song?'} text={``} stepNo={1} gotoStepSong={gotoStepSong} />}
                            <div className={css.tags}>
                                <Chip
                                    label={'Neighboring Rights'}
                                    onDelete={() => {}}
                                    deleteIcon={neighbouringRights ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}
                                />
                                <Chip
                                    label={'Publishing'}
                                    onDelete={() => {}}
                                    deleteIcon={publishing ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}
                                />
                                <Chip
                                    label={'Masters'}
                                    onDelete={() => {}}
                                    deleteIcon={masters ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}
                                />
                                <Chip
                                    label={'Other'}
                                    onDelete={() => {}}
                                    deleteIcon={otherEligible ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}
                                />
                                <Chip
                                    label={'Writer Share Eligible'}
                                    onDelete={() => {}}
                                    deleteIcon={writerShareEligible ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}
                                />
                            </div>
                        </div>
                        <div className={classNames(css.songMeta, css.whiteBgCard)}>
                            <MetaCardInfoRow title={`Main Artist`} text={artist} stepNo={4} gotoStepSong={gotoStepSong} />
                            {featArtists && featArtists.length > 0 && (
                                <MetaCardInfoRow title={'Featured Artists'} text={featArtists.join(', ')} stepNo={4} gotoStepSong={gotoStepSong} />
                            )}
                            {dealDeliveredTo && dealDeliveredTo.length > 0 && (
                                <MetaCardInfoRow title={'Deal delivered to'} text={dealDeliveredTo} stepNo={3} gotoStepSong={gotoStepSong} />
                            )}
                            {releaseDate && releaseDate.length > 0 && (
                                <MetaCardInfoRow title={'Release date'} text={formatDate(releaseDate)} stepNo={4} gotoStepSong={gotoStepSong} />
                            )}
                        </div>
                        {songProjectTrack && songProjectTrack.length > 0 && (
                            <div className={css.songRecordings}>
                                <Typography variant={'h4'} className={'h4Head bold gray title'}>
                                    {'recordings'.toUpperCase()}
                                </Typography>
                                <div className={classNames(css.songMeta, css.whiteBgCard)}>
                                    {currentTrack.map(item => (
                                        <>
                                            {item.releaseDate && item.releaseDate !== '' && (
                                                <MetaCardInfoRow
                                                    title={'Release date'}
                                                    text={formatDate(item.releaseDate)}
                                                    stepNo={4}
                                                    gotoStepSong={gotoStepSong}
                                                />
                                            )}
                                            <MetaCardInfoRow title={'Label'} text={item.trackLabel || ' '} stepNo={3} gotoStepSong={gotoStepSong} />
                                            <MetaCardInfoRow title={'ISRC'} text={item.isrc} stepNo={3} gotoStepSong={gotoStepSong} />
                                            <div className={css.metaRow}>
                                                <Typography variant={'subtitle1'} className={'bold'}>
                                                    UPC
                                                </Typography>
                                                {item.upcList.map(elem => (
                                                    <Typography variant={'subtitle2'} className={'gray'}>
                                                        {elem}
                                                    </Typography>
                                                ))}
                                            </div>
                                        </>
                                    ))}
                                </div>
                                {pageTrack > 1 && (
                                    <Pagination
                                        className={css.pagination}
                                        count={pageTrack}
                                        page={currentPageTrack}
                                        onChange={(event: any, value: any) => {
                                            setCurrentPageTrack(value);
                                        }}
                                        variant="outlined"
                                        shape="rounded"
                                        hideNextButton
                                        hidePrevButton
                                    />
                                )}
                            </div>
                        )}
                        <TwoColumnTable stepNo={5} className={css.keyDates} title={'key dates'} data={keyDatesTableData} gotoStepSong={() => gotoStepSong(6)} />
                        <div>
                            {notesData && notesData.length > 0 && (
                                <div className={css.headesr} style={{ marginBottom: '1rem' }}>
                                    <Typography variant={'h4'} className={'h4Head bold gray title'}>
                                        {'Notes'.toUpperCase()}
                                    </Typography>
                                    <div className={classNames(css.songMeta, css.whiteBgCard, css.songNotes)}>
                                        {notesData.slice(0, 3).map((t: any, i: any) => (
                                            <ListItem>
                                                <ListItemText style={{ wordBreak: 'break-all' }} primary={t.notes} />
                                            </ListItem>
                                        ))}
                                        {notesData.length > 3 && (
                                            <>
                                                <ListItem button onClick={handleClick}>
                                                    <ListItemText primary="Show more" />
                                                    {open ? <ExpandLess /> : <ExpandMore />}
                                                </ListItem>
                                                {notesData.slice(3, notesData.length).map((t: any, i: any) => (
                                                    <Collapse in={open} timeout="auto" unmountOnExit>
                                                        <List component="div" disablePadding>
                                                            <ListItem>
                                                                <ListItemText style={{ wordBreak: 'break-all' }} primary={t.notes} />
                                                            </ListItem>
                                                        </List>
                                                    </Collapse>
                                                ))}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                            <Drawer variant="persistent" anchor={'right'} open={noteDrawer} onClose={() => setNoteDrawer(false)} className={css.drawerStyle}>
                                <Typography
                                    className={css.closedrawer}
                                    onClick={() => {
                                        setNoteDrawer(false);
                                    }}
                                >
                                    <Box component="span" fontSize={40} style={{ cursor: 'pointer' }}>
                                        {/* &larr; */}
                                        <ArrowBackIcon
                                            style={{ verticalAlign: 'center', lineHeight: '10px', cursor: 'pointer' }}
                                            onClick={() => setNoteDrawer(false)}
                                        />
                                    </Box>
                                    <Box component="span" fontSize={15} className={css.closetitle}>
                                        Close
                                    </Box>
                                </Typography>
                                <Divider />
                                <TODODRAWER songId={id} notesData={notesData} toDoData={toDosData} setNotesData={setNotesData} setToDosData={setToDosData} />
                            </Drawer>
                        </div>
                    </div>
                    <div>
                        <div className={css.header1}>
                            <Typography variant={'h4'} className={'h4Head bold gray title'}>
                                {'deals connected'.toUpperCase()}
                            </Typography>
                            <div>
                                <Button className={css.buttonYellow} onClick={() => onlinkDealBtn(true, '', 'ADD DEALS')} style={{ marginRight: '1rem' }}>
                                    Add Deals
                                </Button>
                                <Button className={css.buttonYellow} onClick={() => onlinkDealBtn(true, 'unlink', 'VIEW DEALS')}>
                                    View Deals
                                </Button>
                            </div>
                        </div>
                        <div className={css.connectedDeals}>
                            {currentDeals.map(({ songContractTitle, contactImage }) => (
                                <div key={uuid.v4()} className={classNames(css.whiteBgCard, css.companyCard)}>
                                    <AvatarGroup className={'avatars-group'} max={3}>
                                        <Avatar
                                            variant="square"
                                            className={css.avatarCustomimg}
                                            alt={artist}
                                            src={contactImage ? process.env.REACT_APP_ASSET + contactImage : ''}
                                        />
                                    </AvatarGroup>
                                    <Typography variant={'subtitle1'} className={'bold gray dealTitle'} style={{ marginLeft: '1rem' }}>
                                        {songContractTitle}
                                    </Typography>
                                </div>
                            ))}
                        </div>
                        {pageDeals > 1 && (
                            <Pagination
                                className={css.pagination}
                                count={pageDeals}
                                page={currentPage}
                                onChange={(event: any, value: any) => {
                                    setCurrentPage(value);
                                }}
                                variant="outlined"
                                shape="rounded"
                                hideNextButton
                                hidePrevButton
                            />
                        )}
                        <div>
                            <Typography variant={'h4'} className={'h4Head bold gray title'}>
                                {'DSP'.toUpperCase()}
                            </Typography>
                            <div>
                                <SpotifyIcon
                                    className={css.dspIconSpotify}
                                    onClick={() => {
                                        setDrawerDSPOpen(true);
                                        setDrawerTitle('TRACKS - Spotify');
                                        setDSPType(1);
                                    }}
                                />
                                <AppleIcon
                                    className={css.dspIconApple}
                                    onClick={() => {
                                        setDrawerDSPOpen(true);
                                        setDrawerTitle('TRACKS - Apple Music');
                                        setDSPType(2);
                                    }}
                                />
                                <YouTubeIcon
                                    className={css.dspIconYouTube}
                                    onClick={() => {
                                        setDrawerDSPOpen(true);
                                        setDrawerTitle('TRACKS - YouTube');
                                        setDSPType(3);
                                    }}
                                />
                            </div>
                        </div>

                        <div>
                            <div className={css.header} style={{ marginBottom: '1rem' }}>
                                <Typography variant={'h4'} className={'h4Head bold gray title'}>
                                    {'assets'.toUpperCase()}
                                </Typography>
                                <Button className={css.buttonBlue} onClick={() => gotoStepSong(4)}>
                                    Add Assets
                                </Button>
                            </div>
                            {tagDetails ? (
                                <SongAssets
                                    tagDetails={tagDetails}
                                    deleteAssetsBtn={deleteAssetsBtn}
                                    gotoStepSong={gotoStepSong}
                                    downloadImage={downloadImage}
                                    twoColumns
                                />
                            ) : (
                                ''
                            )}
                        </div>
                        {writerShareEligible ? (
                            <div>
                                <div className={css.songWriter}>
                                    <Typography variant={'h4'} className={'h4Head bold gray title'}>
                                        {'Writer Share'.toUpperCase()}
                                    </Typography>
                                    <VerticalPopver
                                        childClassName={css.editIcon}
                                        styleObj={{ alignSelf: 'center', marginRight: '1.5rem' }}
                                        actionsList={`edit`}
                                        onClickEdit={() => gotoStepSong(2)}
                                    />
                                </div>
                                <table className={css.gridSplits} cellPadding="0" cellSpacing="0">
                                    <tbody>
                                        {writingShare && writingShare > 0 ? (
                                            <Tooltip title={gMyWriterName ? gMyWriterName : ''} placement="bottom" arrow TransitionComponent={Zoom}>
                                                <td className={css.splitsTDFirst} style={{ width: `${writingShare}%` }}>
                                                    {writingShare}%
                                                </td>
                                            </Tooltip>
                                        ) : (
                                            ''
                                        )}
                                        {writingShare < 90 && (
                                            <td className={css.splitsTD} style={{ width: `${100 - writingShare}%` }}>
                                                100%
                                            </td>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            ''
                        )}
                        {publishing ? (
                            <div>
                                <div className={css.songWriter}>
                                    <Typography variant={'h4'} className={'h4Head bold gray title'}>
                                        {'Publisher Share'.toUpperCase()}
                                    </Typography>
                                    <VerticalPopver
                                        childClassName={css.editIcon}
                                        styleObj={{ alignSelf: 'center', marginRight: '1.5rem' }}
                                        actionsList={`edit`}
                                        onClickEdit={() => gotoStepSong(2)}
                                    />
                                </div>
                                <table className={css.gridSplits} cellPadding="0" cellSpacing="0">
                                    <tbody>
                                        {publishingShare && publishingShare > 0 ? (
                                            <Tooltip title={gPublisherName ? gPublisherName : ''} placement="bottom" arrow TransitionComponent={Zoom}>
                                                <td className={css.splitsTDFirst} style={{ width: `${publishingShare}%` }}>
                                                    {publishingShare}%
                                                </td>
                                            </Tooltip>
                                        ) : (
                                            ''
                                        )}
                                        {publishingShare < 90 && (
                                            <td className={css.splitsTD} style={{ width: `${100 - publishingShare}%` }}>
                                                {publishingShare !== 100 && '100%'}
                                            </td>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
